document.addEventListener('DOMContentLoaded', function () {

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal) {
        return
      }
      this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  const newHeaderWrapper = document.querySelector('.header-wrapper--new');

  if (newHeaderWrapper) {
    const headerLinks = newHeaderWrapper.querySelectorAll('nav details');

    headerLinks.forEach(function(link) {
      if (!link.parentElement.classList.contains('header__search')) {
        link.addEventListener('mouseenter', function() {
          let top = 0;

          const annBar = document.getElementById('announcements-slider');
          if (annBar && annBar.offsetParent !== null && annBar.getBoundingClientRect().bottom > 0) {
            top += annBar.offsetHeight;
          }

          const headerEl = document.querySelector('.header-menu-new-version');
          if (headerEl && headerEl.offsetParent !== null && headerEl.getBoundingClientRect().bottom > 0) {
            top += headerEl.offsetHeight;
          }

          newHeaderWrapper.style.setProperty('--submenu-top-new', top + 'px');
          this.setAttribute('open', '');
        });

        link.addEventListener('mouseleave', function(e) {
          this.removeAttribute('open');
        });
      }
    });

    const menuProductLinks = newHeaderWrapper.querySelectorAll('li[menu-product]');
    const submenuImage = newHeaderWrapper.querySelector('img[submenu-image]');
    if (submenuImage) {
      const submenuImageDefault = submenuImage.dataset.submenuImageDefault;

      menuProductLinks.forEach(function(link) {
        link.addEventListener('mouseenter', function() {
          const img = this.dataset.menuProductImage;
          submenuImage.src = img;
        });

        link.addEventListener('mouseleave', function() {
          submenuImage.src = submenuImageDefault;
        });
      });
    }
  }

})
